import { useMutation } from "@apollo/client";
import {
  GetOrderByIdDocument,
  UpdateOrderProductsDocument,
} from "../../gql/generated/graphql";
import {
  updateProductArgsToInput,
  type UpdateProductArgs,
} from "./productInputs";

interface Props {
  orderId: string;
}

export const useUpdateProducts = ({ orderId }: Props) => {
  const [updateProductsMutation, { loading: isUpdatingProducts }] = useMutation(
    UpdateOrderProductsDocument,
    {
      refetchQueries: [GetOrderByIdDocument],
      awaitRefetchQueries: true,
    }
  );

  const updateProducts = (products: UpdateProductArgs[]) =>
    updateProductsMutation({
      variables: {
        orderId,
        products: products.map(args => ({
          productId: args.productId,
          input: updateProductArgsToInput(args),
        })),
      },
    });

  return {
    updateProducts,
    isUpdatingProducts,
  };
};
